const READING_KEY = "fu-research-reading-progress-v1";
const SAVED_KEY = "fu-research-saved-v1";

const readJson = (key, fallback) => {
  if (typeof window === "undefined") return fallback;
  try {
    const value = JSON.parse(window.localStorage.getItem(key));
    return value ?? fallback;
  } catch {
    return fallback;
  }
};

const writeJson = (key, value) => {
  if (typeof window === "undefined") return false;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};

export const getReadingHistory = () => {
  const records = readJson(READING_KEY, []);
  return Array.isArray(records) ? records.filter((record) => record?.slug && Number.isFinite(record?.progress) && record?.timestamp) : [];
};

export const getReadingRecord = (slug) => getReadingHistory().find((record) => record.slug === slug);

export const saveReadingRecord = (slug, progress) => {
  const nextRecord = { slug, progress: Math.max(0, Math.min(100, Math.round(progress))), timestamp: new Date().toISOString() };
  const records = getReadingHistory().filter((record) => record.slug !== slug);
  return writeJson(READING_KEY, [...records, nextRecord]) ? nextRecord : null;
};

export const removeReadingRecord = (slug) => writeJson(READING_KEY, getReadingHistory().filter((record) => record.slug !== slug));

export const getSavedResearch = () => {
  const slugs = readJson(SAVED_KEY, []);
  return Array.isArray(slugs) ? [...new Set(slugs.filter((slug) => typeof slug === "string"))] : [];
};

export const setResearchSaved = (slug, saved) => {
  const current = getSavedResearch().filter((savedSlug) => savedSlug !== slug);
  const next = saved ? [...current, slug] : current;
  return writeJson(SAVED_KEY, next) ? next : getSavedResearch();
};